import Logo from 'assets/img/layout/logo.png'
import { Link, useLocation } from 'react-router-dom'
import { IoMdSettings } from 'react-icons/io'
import { LuArrowUpToLine } from 'react-icons/lu'
import ReactTooltip from 'react-tooltip'
import SocialMedia from 'static/SocialMedia'

const Footer = () => {
	const location = useLocation()

	return (
		<footer className="mt-auto flex w-full flex-col items-center justify-between dark:text-white xl:flex-row">
			<div className="container px-3 py-3 lg:px-5">
				<div className="flex w-full flex-row flex-wrap items-center justify-between py-2 md:py-3">
					<div className="flex">
						{SocialMedia.map((media, index) => (
							<Link
								key={index}
								to={media.href}
								target="_blank"
								className="mr-2"
								data-tip={media.href}
								data-for="social-tip"
							>
								<media.icon className="text-lg text-main-black hover:text-hover-green" />
							</Link>
						))}
					</div>
					<Link
						to="#"
						className="btn-xs btn-outline flex cursor-pointer select-none items-center rounded-[10px] !py-1 outline-none dark:text-gray-700"
					>
						<LuArrowUpToLine /> <span className="ml-2">Back to Top</span>
					</Link>
				</div>
				<div className="flex w-full flex-row flex-wrap items-center justify-center border-y-[1px] border-gray-100 pt-2 dark:border-lightGrey md:justify-between">
					<div className="flex flex-row flex-wrap items-center justify-center gap-1 pb-1.5 xl:justify-start">
						<div className="bg-neutral8 flex flex-row flex-wrap items-center justify-center rounded-full">
							<img width={31} height={31} className="mr-1" src={Logo} alt="Logo" />
						</div>
						<div className="text-small !font-bold not-italic text-gray-900 dark:text-white">
							Powered by BTI Group OÜ
						</div>
					</div>
					<div className="flex flex-row flex-wrap items-center justify-center gap-2 pb-1.5 xl:justify-end">
						<Link
							to="/terms-of-service"
							className={`px-2 ${location.pathname === '/terms-of-service' ? 'text-green-800' : ''}`}
						>
							Terms of Service
						</Link>
						<Link
							to="/privacy-policy"
							className={`px-2 ${location.pathname === '/privacy-policy' ? 'text-green-800' : ''}`}
						>
							Privacy Policy
						</Link>
						<Link to="/contact" className={`px-2 ${location.pathname === '/contact' ? 'text-green-800' : ''}`}>
							Contact Us
						</Link>
						<Link to="#" className={`px-2 ${location.pathname === '/advertise' ? 'text-green-800' : ''}`}>
							Advertise
						</Link>
						<Link to="#" className={`px-2 ${location.pathname === '/knowledge' ? 'text-green-800' : ''}`}>
							Knowledge Hub
						</Link>
						<Link to="#" className={`px-2 ${location.pathname === '/resources' ? 'text-green-800' : ''}`}>
							Resources
						</Link>
						<Link
							to="/settings"
							className={`text-large mt-[-3px] text-gray-900 hover:text-green-900 dark:text-white ${
								location.pathname === '/settings' ? 'text-green-800 dark:text-green-800' : ''
							}`}
						>
							<IoMdSettings />
						</Link>
					</div>
				</div>
				<div className="flex w-full flex-col flex-wrap items-center justify-between gap-2.5 py-2 md:flex-row md:py-3">
					<div className="text-small text-lightGrey dark:text-gray-500">
						BBAScan &copy; {new Date().getFullYear()}. All Rights Reserved.
					</div>
					{/* <div className="text-small flex flex-wrap">
            <span className="mr-1 text-red-600">Donations: </span>
            <span className="text-green-900">0x8186b214...A30EE8810</span>
          </div> */}
				</div>
			</div>
			<ReactTooltip id="social-tip" place="top" effect="solid" class="custom-tooltip top" />
		</footer>
	)
}

export default Footer
